export default {"src":"/_next/static/media/recipe-book.6864188b.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};